/**
 * Copyright (C) 2024-present Puter Technologies Inc.
 *
 * This file is part of Puter.
 *
 * Puter is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

const hy = {
    name: "Հայերեն",
    english_name: "Armenian",
    code: "hy",
    dictionary: {
        about: "Մեր մասին",
        account: "Հաշիվ",
        account_password: "Հաստատել հաշվի գաղտնաբառը",
        access_granted_to: "Մուտքը տրված է՝",
        add_existing_account: "Ավելացնել առկա հաշիվ",
        all_fields_required: "Բոլոր դաշտերը պարտադիր են",
        allow: "Թույլատրել",
        apply: "Կիրառել",
        ascending: "Աճող",
        associated_websites: "Կապված կայքեր",
        auto_arrange: "Ավտոմատ դասավորել",
        background: "Ֆոն",
        browse: "Թերթել",
        cancel: "Չեղարկել",
        center: "Կենտրոն",
        change_desktop_background: "Փոխել աշխատասեղանի ֆոնը…",
        change_email: "Փոխել էլ. փոստը",
        change_language: "Փոխել լեզուն",
        change_password: "Փոխել գաղտնաբառը",
        change_ui_colors: "Փոխել UI գույները",
        change_username: "Փոխել օգտանունը",
        close: "Փակել",
        close_all_windows: "Փակել բոլոր պատուհանները",
        close_all_windows_confirm: "Վստա՞հ եք, որ ցանկանում եք փակել բոլոր պատուհանները:",
        close_all_windows_and_log_out: "Փակել պատուհաններն ու դուրս գալ",
        change_always_open_with: "Ցանկանու՞մ եք այս տեսակի ֆայլը միշտ բացել",
        color: "Գույն",
        confirm: "Հաստատել",
        confirm_2fa_setup: "Ես ավելացրել եմ կոդը իմ իսկորոշիչ հավելվածում",
        confirm_2fa_recovery: "Ես պահել եմ վերականգնման կոդերը ապահով վայրում",
        confirm_account_for_free_referral_storage_c2a: "Ստեղծեք հաշիվ և հաստատեք ձեր էլ. հասցեն 1 ԳԲ անվճար պահեստ ստանալու համար: Ձեր ընկերը նույնպես կստանա 1 ԳԲ անվճար պահեստ:",
        confirm_code_generic_incorrect: "Սխալ կոդ:",
        confirm_code_generic_too_many_requests: "Չափազանց շատ հարցումներ: Խնդրում ենք սպասել մի քանի րոպե:",
        confirm_code_generic_submit: "Հաստատել կոդը",
        confirm_code_generic_try_again: "Կրկին փորձեք",
        confirm_code_generic_title: "Մուտքագրեք հաստատման կոդը",
        confirm_code_2fa_instruction: "Մուտքագրեք 6 նիշանոց կոդը ձեր իսկորոշիչ հավելվածից:",
        confirm_code_2fa_submit_btn: "Հաստատել",
        confirm_code_2fa_title: "Մուտքագրեք 2FA կոդը",
        confirm_delete_multiple_items: "Վստա՞հ եք, որ ցանկանում եք ընդմիշտ ջնջել այս տարրերը:",
        confirm_delete_single_item: "Ցանկանու՞մ եք ընդմիշտ ջնջել այս տարրը:",
        confirm_open_apps_log_out: "Դուք ունեք բաց հավելվածներ: Վստա՞հ եք, որ ցանկանում եք դուրս գալ:",
        confirm_new_password: "Հաստատել նոր գաղտնաբառը",
        confirm_delete_user: "Վստա՞հ եք, որ ցանկանում եք ջնջել ձեր հաշիվը: Ձեր բոլոր ֆայլերը և տվյալները ընդմիշտ կջնջվեն: Այս գործողությունը հնարավոր չէ հետարկել:",
        confirm_delete_user_title: "Ջնջել հաշիվը?",
        confirm_session_revoke: "Վստա՞հ եք, որ ցանկանում եք չեղարկել այս սեսիան:",
        confirm_your_email_address: "Հաստատեք ձեր էլ. փոստի հասցեն",
        contact_us: "Հետադարձ կապ",
        contact_us_verification_required: "Սա օգտագործելու համար դուք պետք է ունենաք հաստատված էլ․ հասցե։:",
        contain: "Պարունակել",
        continue: "Շարունակել",
        copy: "Պատճենել",
        copy_link: "Պատճենել հղումը",
        copying: "Պատճենվում է",
        copying_file: "Պատճենվում է %%",
        cover: "Ծածկոց",
        create_account: "Ստեղծել հաշիվ",
        create_free_account: "Ստեղծել անվճար հաշիվ",
        create_shortcut: "Ստեղծել դյուրանցում",
        credits: "Կրեդիտներ",
        current_password: "Ընթացիկ գաղտնաբառ",
        cut: "Կտրել",
        clock: "Ժամացույց",
        clock_visible_hide: "Թաքցնել - Միշտ թաքնված",
        clock_visible_show: "Ցուցադրել - Միշտ տեսանելի",
        clock_visible_auto: "Ավտոմատ - լռելյայն, տեսանելի միայն ամբողջական էկրանային ռեժիմում:",
        close_all: "Փակել բոլորը",
        created: "Ստեղծված",
        date_modified: "Փոփոխման ամսաթիվ",
        default: "Լռելյայն",
        delete: "Ջնջել",
        delete_account: "Ջնջել հաշիվը",
        delete_permanently: "Ընդմիշտ ջնջել",
        deleting_file: "Ջնջվում է %%",
        deploy_as_app: "Տեղադրել որպես հավելված",
        descending: "Նվազող",
        desktop: "Աշխատասեղան",
        desktop_background_fit: "Հարմարեցնել",
        developers: "Ծրագրավորողներ",
        dir_published_as_website: "%strong% հրապարակվել է",
        disable_2fa: "Անջատել 2FA",
        disable_2fa_confirm: "Վստա՞հ եք, որ ցանկանում եք անջատել 2FA-ն:",
        disable_2fa_instructions: "Մուտքագրեք ձեր գաղտնաբառը՝ 2FA-ն անջատելու համար:",
        disassociate_dir: "Անջատել պանակը",
        documents: "Փաստաթղթեր",
        dont_allow: "Թույլ չտալ",
        download: "Ներբեռնել",
        download_file: "Ներբեռնել ֆայլը",
        downloading: "Ներբեռնվում է",
        email: "Էլեկտրոնային հասցե",
        email_change_confirmation_sent: "Հաստատման նամակը ուղարկվել է ձեր նոր էլ. հասցեին։ Խնդրում ենք ստուգեք ձեր փոստարկղը և հետևեք ցուցումներին՝ գործընթացը ավարտելու համար:",
        email_invalid: "Էլ. հասցեն անվավեր է:",
        email_or_username: "Էլ․ հասցե կամ օգտանուն",
        email_required: "Էլ. հասցեն պարտադիր է:",
        empty_trash: "Դատարկել աղբարկղը",
        empty_trash_confirmation: "Իսկապե՞ս ուզում եք ընդմիշտ ջնջել աղբարկղում գտնվող տարրերը:",
        emptying_trash: "Աղբարկղը դատարկվում է…",
        enable_2fa: "Միացնել 2FA",
        end_hard: "Ավարտել խիստ",
        end_process_force_confirm: "Վստա՞հ եք, որ ցանկանում եք հարկադրաբար կանգնեցնել այս գործընթացը:",
        end_soft: "Ավարտել մեղմ",
        enlarged_qr_code: "Մեծացված QR-կոդ",
        enter_password_to_confirm_delete_user: "Մուտքագրեք ձեր գաղտնաբառը՝ հաշվի ջնջումը հաստատելու համար",
        error_message_is_missing: "Սխալի մասին հաղորդագրությունը բացակայում է:",
        error_unknown_cause: "Անհայտ սխալ է տեղի ունեցել:",
        error_uploading_files: "Չհաջողվեց վերբեռնել ֆայլերը",
        favorites: "Նախընտրածներ",
        feedback: "Հետադարձ կապ",
        feedback_c2a: "Խնդրում ենք օգտագործել ստորև բերված ձևը՝ մեզ ուղարկելու ձեր կարծիքը, մեկնաբանությունները և վրիպակների հաղորդումները:",
        feedback_sent_confirmation: "Շնորհակալություն մեզ հետ կապվելու համար: Եթե ձեր հաշվի հետ կապված էլ. հասցե ունեք, հնարավորինս շուտ կպատասխանենք ձեզ:",
        fit: "Հարմարեցնել",
        folder: "Պանակ",
        force_quit: "Հարկադրված ելք",
        forgot_pass_c2a: "Մոռացե՞լ եք գաղտնաբառը",
        from: "Ումից՝",
        general: "Ընդհանուր",
        get_a_copy_of_on_puter: "Ստանալ '%%'-ի պատճենը Puter.com-ում!",
        get_copy_link: "Ստանալ պատճենված հղումը",
        hide_all_windows: "Թաքցնել բոլոր պատուհանները",
        home: "Գլխավոր",
        html_document: "HTML փաստաթուղթ",
        hue: "Երանգ",
        image: "Պատկեր",
        incorrect_password: "Սխալ գաղտնաբառ",
        invite_link: "Հրավերի հղում",
        item: "տարր",
        items_in_trash_cannot_be_renamed: "Այս տարրը չի կարող վերանվանվել, քանի որ այն աղբարկղում է: Այս տարրը վերանվանելու համար նախ տեղափոխեք այն աղբարկղից:",
        jpeg_image: "JPEG պատկեր",
        keep_in_taskbar: "Պահպանել խնդրագոտում",
        language: "Լեզու",
        license: "Լիցենզիա",
        lightness: "Լուսավորություն",
        link_copied: "Հղումը պատճենվել է",
        loading: "Բեռնում",
        log_in: "Մուտք գործել",
        log_into_another_account_anyway: "Այնուամենայնիվ, մուտք գործեք մեկ այլ հաշիվ",
        log_out: "Դուրս գալ",
        looks_good: "Լավ է նայվում!",
        manage_sessions: "Սեսիաների կառավարում",
        modified: "Փոփոխված",
        move: "Տեղափոխել",
        moving_file: "Տեղափոխվում է %%",
        my_websites: "Իմ կայքերը",
        name: "Անուն",
        name_cannot_be_empty: "Անվան դաշտը չի կարող լինել դատարկ:",
        name_cannot_contain_double_period: "Անունը չի կարող լինել '..' նիշը:",
        name_cannot_contain_period: "Անունը չի կարող լինել '.' նիշը:",
        name_cannot_contain_slash: "Անունը չի կարող պարունակել '/' նիշը:",
        name_must_be_string: "Անունը կարող է լինել միայն տող:",
        name_too_long: "Անունը չի կարող լինել ավելի քան %% նիշ:",
        new: "Նոր",
        new_email: "Նոր էլ. հասցե",
        new_folder: "Նոր պանակ",
        new_password: "Նոր գաղտնաբառ",
        new_username: "Նոր օգտանուն",
        no: "Ոչ",
        no_dir_associated_with_site: "Այս հասցեի հետ կապված պանակ չկա:",
        no_websites_published: "Դուք դեռ ոչ մի կայք չեք հրապարակել։ Սկսելու համար թղթապանակի վրա սեղմեք աջ",
        ok: "Լավ",
        open: "Բացել",
        open_in_new_tab: "Բացել նոր ներդիրով",
        open_in_new_window: "Բացել նոր պատուհանում",
        open_with: "Բացել հավելվածով",
        original_name: "սկզբնական անուն",
        original_path: "սկզբնական ուղի",
        oss_code_and_content: "Բաց կոդով ծրագրակազմ և բովանդակություն",
        password: "Գաղտնաբառ",
        password_changed: "Գաղտնաբառը փոփոխված է",
        password_recovery_rate_limit: "Դուք հասել եք մեր արագության սահմանաչափին. խնդրում ենք սպասել մի քանի րոպե: Ապագայում սա կանխելու համար խուսափեք էջը շատ անգամներ վերաբեռնելուց:",
        password_recovery_token_invalid: "Այս գաղտնաբառի վերականգնման տոկենը այլևս վավեր չէ:",
        password_recovery_unknown_error: "Անհայտ սխալ է տեղի ունեցել: Խնդրում ենք փորձել ավելի ուշ:",
        password_required: "Գաղտնաբառը պարտադիր է:",
        password_strength_error: "Գաղտնաբառը պետք է լինի առնվազն 8 նիշ երկարությամբ և պարունակի առնվազն մեկ մեծատառ, մեկ փոքրատառ, մեկ թիվ և մեկ հատուկ նիշ:",
        passwords_do_not_match: "«Նոր գաղտնաբառ» և «Հաստատել նոր գաղտնաբառը» չեն համընկնում:",
        paste: "Տեղադրել",
        paste_into_folder: "Տեղադրել պանակում",
        path: "Ուղի",
        personalization: "Անհատականացում",
        pick_name_for_website: "Ընտրեք անուն ձեր կայքի համար",
        picture: "Նկար",
        pictures: "Նկարներ",
        plural_suffix: "ներ",
        powered_by_puter_js: "Աջակցվում է {{link=docs}}Puter.js{{/link}}-ի կողմից",
        preparing: "Պատրաստվում է...",
        preparing_for_upload: "Պատրաստվում է վերբեռնել...",
        print: "Տպել",
        privacy: "Գաղտնիություն",
        proceed_to_login: "Շարունակել մուտք գործելը",
        proceed_with_account_deletion: "Շարունակել հաշվի ջնջումը",
        process_status_initializing: "Սկսում է",
        process_status_running: "Աշխատում է",
        process_type_app: "Հավելված",
        process_type_init: "Սկսում",
        process_type_ui: "UI",
        properties: "Հատկություններ",
        public: "Հանրային",
        publish: "Հրապարակել",
        publish_as_website: "Հրապարակել որպես կայք",
        puter_description: "Փութերը գաղտնիության առաջնահերթություն ունեցող անձնական ամպ է՝ ձեր բոլոր ֆայլերը, հավելվածները և խաղերը մեկ անվտանգ տեղում պահելու համար, որը հասանելի է ցանկացած վայրից ցանկացած ժամանակ:",
        reading_file: "Ընթերցում է %strong%",
        recent: "Վերջին",
        recommended: "Խորհուրդ է տրվում",
        recover_password: "Վերականգնել գաղտնաբառը",
        refer_friends_c2a: "Ստացեք 1 ԳԲ յուրաքանչյուր ընկերոջ համար, ով ստեղծում և հաստատում է հաշիվ Փութերում: Ձեր ընկերը նույնպես կստանա 1 ԳԲ!",
        refer_friends_social_media_c2a: "Ստացեք 1 ԳԲ անվճար պահեստ Puter.com-ում!",
        refresh: "Թարմացնել",
        release_address_confirmation: "Իսկապե՞ս ուզում եք թողարկել այս հասցեն:",
        remove_from_taskbar: "Հանել խնդրագոտուց",
        rename: "Վերանվանել",
        repeat: "Կրկնել",
        replace: "Փոխարինել",
        replace_all: "Փոխարինել բոլորը",
        resend_confirmation_code: "Նորից ուղարկել հաստատման կոդը",
        reset_colors: "Վերականգնել գույները",
        restart_puter_confirm: "Վստա՞հ եք, որ ցանկանում եք վերագործարկել Փութերը:",
        restore: "Վերականգնել",
        save: "Պահպանել",
        saturation: "Հագեցվածություն",
        save_account: "Պահպանել հաշիվը",
        save_account_to_get_copy_link: "Շարունակելու համար խնդրում ենք ստեղծել հաշիվ:",
        save_account_to_publish: "Շարունակելու համար խնդրում ենք ստեղծել հաշիվ:",
        save_session: "Պահպանել սեսիան",
        save_session_c2a: "Ստեղծեք հաշիվ՝ ձեր ընթացիկ սեսիան պահպանելու և աշխատանքը չկորցնելու համար:",
        scan_qr_c2a: "Սկանավորեք ստորև նշված կոդը՝\nայլ սարքերից այս սեսիա մուտք գործելու համար",
        scan_qr_2fa: "Սկանավորեք QR-կոդը ձեր իսկորոշիչ հավելվածով",
        scan_qr_generic: "Սկանավորեք այս QR-կոդը ձեր հեռախոսով կամ այլ սարքով",
        search: "Որոնել",
        seconds: "վայրկյաններ",
        security: "Անվտանգություն",
        select: "Ընտրել",
        selected: "ընտրված",
        select_color: "Ընտրել գույնը…",
        sessions: "Սեսիաներ",
        send: "Ուղարկել",
        send_password_recovery_email: "Ուղարկել գաղտնաբառի վերականգնման էլ․փոստի նամակ",
        session_saved: "Շնորհակալություն հաշիվ ստեղծելու համար: Այս սեսիան պահպանվել է:",
        settings: "Կարգավորումներ",
        set_new_password: "Սահմանել նոր գաղտնաբառ",
        share: "Տարածել",
        share_to: "Տարածել դեպի",
        share_with: "Տարածել հետ՝",
        shortcut_to: "Դյուրանցում դեպի",
        show_all_windows: "Ցույց տալ բոլոր պատուհանները",
        show_hidden: "Ցույց տալ թաքնված տարրերը",
        sign_in_with_puter: "Մուտք գործել Փութերի միջոցով",
        sign_up: "Գրանցվել",
        signing_in: "Մուտք է գործում…",
        size: "Չափ",
        skip: "Բաց թողնել",
        something_went_wrong: "Ինչ-որ բան սխալ գնաց:",
        sort_by: "Տեսակավորել ըստ՝",
        start: "Սկսել",
        status: "Կարգավիճակ",
        storage_usage: "Պահեստի օգտագործում",
        storage_puter_used: "օգտագործվում է Փութերի կողմից",
        taking_longer_than_usual: "Սովորականից մի փոքր ավելի երկար է տևում: Խնդրում ենք սպասել...",
        task_manager: "Առաջադրանքների կառավարիչ",
        taskmgr_header_name: "Անուն",
        taskmgr_header_status: "Կարգավիճակ",
        taskmgr_header_type: "Տեսակ",
        terms: "Պայմաններ",
        text_document: "Տեքստային փաստաթուղթ",
        tos_fineprint: "Սեղմելով «Ստեղծել անվճար հաշիվ»՝ դուք համաձայնում եք Փութերի {{link=terms}}ծառայությունների պայմաններին{{/link}} և {{link=privacy}}գաղտնիության քաղաքականությանը{{/link}}:",
        transparency: "Թափանցիկություն",
        trash: "Աղբարկղ",
        two_factor: "Երկու գործոնով նույնականացում",
        two_factor_disabled: "2FA-ն անջատված է",
        two_factor_enabled: "2FA-ն միացված է",
        type: "Տեսակ",
        type_confirm_to_delete_account: "Հաշիվը ջնջելու համար գրեք 'confirm':",
        ui_colors: "UI գույներ",
        ui_manage_sessions: "Սեսիայի կառավարիչ",
        ui_revoke: "Հետ կանչել",
        undo: "Հետարկել",
        unlimited: "Անսահմանափակ",
        unzip: "Արխիվից հանել",
        upload: "Վերբեռնել",
        upload_here: "Վերբեռնել այստեղ",
        usage: "Օգտագործում",
        username: "Օգտանուն",
        username_changed: "Օգտանունը հաջողությամբ թարմացվել է:",
        username_required: "Օգտանունը պարտադիր է:",
        versions: "Տարբերակներ",
        videos: "Տեսանյութեր",
        visibility: "Տեսանելիություն",
        yes: "Այո",
        yes_release_it: "Այո, թողարկեք այն",
        you_have_been_referred_to_puter_by_a_friend: "Դուք ուղղորդվել եք Փութեր ձեր ընկերոջ կողմից!",
        zip: "Ավելացնել արխիվում",
        zipping_file: "Ավելացվում է արխիվում %strong%-ը",

        // === 2FA Setup ===
        setup2fa_1_step_heading: "Բացեք ձեր իսկորոշիչ հավելվածը",
        setup2fa_1_instructions: `
        Դուք կարող եք օգտագործել ցանկացած իսկորոշիչ հավելված, որն աջակցում է ժամանակի վրա հիմնված միանգամյա գաղտնաբառ (TOTP) պրոտոկոլը:
        Կան բազմաթիվ տարբերակներ, բայց եթե վստահ չեք,
        <a target="_blank" href="https://authy.com/download">Authy</a>
        լավ ընտրություն է Android-ի և iOS-ի համար:
    `,
        setup2fa_2_step_heading: "Սկանավորեք QR-կոդը",
        setup2fa_3_step_heading: "Մուտքագրեք 6 նիշանոց կոդը",
        setup2fa_4_step_heading: "Պատճենեք ձեր վերականգնման կոդերը",
        setup2fa_4_instructions: `
        Այս վերականգնման կոդերը միակ միջոցն են մուտք գործելու ձեր հաշիվ, եթե կորցնեք ձեր հեռախոսը կամ չկարողանաք օգտագործել ձեր իսկորոշիչ հավելվածը:
        Պարտադիր դրանք պահեք ապահով վայրում:
    `,
        setup2fa_5_step_heading: "Հաստատեք 2FA կարգավորումը",
        setup2fa_5_confirmation_1: "Ես իմ վերականգնման կոդերը պահել եմ ապահով վայրում",
        setup2fa_5_confirmation_2: "Ես պատրաստ եմ միացնել 2FA",
        setup2fa_5_button: "Միացնել 2FA",

        // === 2FA Login ===
        login2fa_otp_title: "Մուտքագրեք 2FA կոդը",
        login2fa_otp_instructions: "Մուտքագրեք 6 նիշանոց կոդը ձեր իսկորոշիչ հավելվածից:",
        login2fa_recovery_title: "Մուտքագրեք վերականգնման կոդը",
        login2fa_recovery_instructions: "Մուտքագրեք ձեր վերականգնման կոդերից մեկը ձեր հաշիվ մուտք գործելու համար:",
        login2fa_use_recovery_code: "Օգտագործել վերականգնման կոդը",
        login2fa_recovery_back: "Հետ",
        login2fa_recovery_placeholder: "XXXXXXXX",

        change: "Փոփոխել",
        clock_visibility: "Ժամացույցի տեսանելիություն",
        reading: "Ընթերցում",
        writing: "Գրում",
        unzipping: "Արխիվը բացել",
        sequencing: "Հաջորդականություն",
        zipping: "Արխիվացում",
        Editor: "Խմբագրիչ",
        Viewer: "Դիտորդ",
        "People with access": "Մուտքի իրավունք ունեցող անձինք",
        "Share With…": "Կիսվել…",
        Owner: "Սեփականատեր",
        "You can’t share with yourself.": "Դուք չեք կարող կիսվել ինքներդ ձեզ հետ։",
        "This user already has access to this item": "Այս օգտատերն արդեն մուտքի իրավունք ունի։",
        "You can't share with yourself.": "Դուք չեք կարող կիսվել ինքներդ ձեզ հետ",
        "billing.change_payment_method": "Փոխել",
        "billing.cancel": "Չեղարկել",
        "billing.download_invoice": "Ներբեռնել",
        "billing.payment_method": "Վճարման եղանակ",
        "billing.payment_method_updated": "Վճարման եղանակը թարմացվել է",
        "billing.confirm_payment_method": "Հաստատեք վճարման եղանակը",
        "billing.payment_history": "Վճարումների պատմություն",
        "billing.refunded": "Վերադարձվել է",
        "billing.paid": "Վճարված",
        "billing.ok": "Լավ",
        "billing.resume_subscription": "Երկարացնել բաժանորդագրությունը",
        "billing.subscription_cancelled": "Ձեր բաժանորդագրությունը չեղարկվել է",
        "billing.subscription_cancelled_description": "Դուք դեռ կունենաք ձեր բաժանորդագրությանը մուտք մինչև այս վճարային ժամանակահատվածի ավարտը",
        "billing.offering.free": "Անվճար",
        "billing.offering.pro": "Պրոֆեսիոնալ",
        "billing.offering.professional": "Պրոֆեսիոնալ",
        "billing.offering.business": "Բիզնես",
        "billing.cloud_storage": "Ամպային պահեստավորում",
        "billing.ai_access": "ԱԲ հասանելիություն",
        "billing.bandwidth": "Լայնաշերտ",
        "billing.apps_and_games": "Ծրագրեր և խաղեր",
        "billing.upgrade_to_pro": "Թարմացնել %strong%",
        "billing.switch_to": "Անցնել դեպի %strong%",
        "billing.payment_setup": "Վճարման կարգավորում",
        "billing.back": "Հետ",
        "billing.you_are_now_subscribed_to": "Դուք այժմ բաժանորդագրված եք %strong% պլանին",
        "billing.you_are_now_subscribed_to_without_tier": "Դուք այժմ բաժանորդագրված եք",
        "billing.subscription_cancellation_confirmation": "Վստա՞հ եք, որ ցանկանում եք չեղարկել բաժանորդագրությունը",
        "billing.subscription_setup": "Բաժանորդագրության կարգավորում",
        "billing.cancel_it": "Չեղարկել",
        "billing.keep_it": "Պահպանել",
        "billing.subscription_resumed": "Ձեր %strong% բաժանորդագրությունը վերականգնվել է",
        "billing.upgrade_now": "Թարմացնել հիմա",
        "billing.upgrade": "Թարմացնել",
        "billing.currently_on_free_plan": "Դուք ներկայումս գտնվում եք անվճար պլանի վրա",
        "billing.download_receipt": "Ներբեռնել անդորրագիրը",
        "billing.subscription_check_error": "Պրոբլեմ առաջացավ բաժանորդագրության կարգավիճակը ստուգելիս",
        "billing.email_confirmation_needed": "Ձեր էլ. փոստը դեռևս հաստատված չէ։ Մենք կուղարկենք հաստատման կոդ հիմա",
        "billing.sub_cancelled_but_valid_until": "Դուք չեղարկել եք ձեր բաժանորդագրությունը, և այն ավտոմատ կփոխվի անվճար պլանի՝ վճարային ժամանակահատվածի ավարտին։ Ձեզնից այլևս չի գանձվի, եթե նորից չբաժանորդագրվեք",
        "billing.current_plan_until_end_of_period": "Ձեր ընթացիկ պլանը մինչև վճարային ժամանակահատվածի ավարտը",
        "billing.current_plan": "Ընթացիկ պլան",
        "billing.cancelled_subscription_tier": "Չեղարկված բաժանորդագրություն (%%)",
        "billing.manage": "Կառավարել",
        "billing.limited": "Սահմանափակված",
        "billing.expanded": "Ընդլայնված",
        "billing.accelerated": "Արագացված",
        "billing.enjoy_msg": "Վայելեք %% ամպային պահեստավորում և այլ առավելություններ",

        // =============================================================
        // Missing translations
        // =============================================================
        "choose_publishing_option": undefined, // In English: "Choose how you want to publish your website:"
        "create_desktop_shortcut": undefined, // In English: "Create Shortcut (Desktop)"
        "create_desktop_shortcut_s": undefined, // In English: "Create Shortcuts (Desktop)"
        "create_shortcut_s": undefined, // In English: "Create Shortcuts"
        "minimize": undefined, // In English: "Minimize"
        "reload_app": undefined, // In English: "Reload App"
        "new_window": undefined, // In English: "New Window"
        "open_trash": undefined, // In English: "Open Trash"
        "pick_name_for_worker": undefined, // In English: "Pick a name for your worker:"
        "publish_as_serverless_worker": undefined, // In English: "Publish as Worker"
        "toolbar.enter_fullscreen": undefined, // In English: "Enter Full Screen"
        "toolbar.github": undefined, // In English: "GitHub"
        "toolbar.refer": undefined, // In English: "Refer"
        "toolbar.save_account": undefined, // In English: "Save Account"
        "toolbar.search": undefined, // In English: "Search"
        "toolbar.qrcode": undefined, // In English: "QR Code"
        "used_of": undefined, // In English: "{{used}} used of {{available}}"
        "worker": undefined, // In English: "Worker"
        "billing.offering.basic": undefined, // In English: "Basic"
        "too_many_attempts": undefined, // In English: "Too many attempts. Please try again later."
        "server_timeout": undefined, // In English: "The server took too long to respond. Please try again."
        "signup_error": undefined, // In English: "An error occurred during signup. Please try again."
        "welcome_title": undefined, // In English: "Welcome to your Personal Internet Computer"
        "welcome_description": undefined, // In English: "Store files, play games, find awesome apps, and much more! All in one place, accessible from anywhere at any time."
        "welcome_get_started": undefined, // In English: "Get Started"
        "welcome_terms": undefined, // In English: "Terms"
        "welcome_privacy": undefined, // In English: "Privacy"
        "welcome_developers": undefined, // In English: "Developers"
        "welcome_open_source": undefined, // In English: "Open Source"
        "welcome_instant_login_title": undefined, // In English: "Instant Login!"
        "alert_error_title": undefined, // In English: "Error!"
        "alert_warning_title": undefined, // In English: "Warning!"
        "alert_info_title": undefined, // In English: "Info"
        "alert_success_title": undefined, // In English: "Success!"
        "alert_confirm_title": undefined, // In English: "Are you sure?"
        "alert_yes": undefined, // In English: "Yes"
        "alert_no": undefined, // In English: "No"
        "alert_retry": undefined, // In English: "Retry"
        "alert_cancel": undefined, // In English: "Cancel"
        "signup_confirm_password": undefined, // In English: "Confirm Password"
        "login_email_username_required": undefined, // In English: "Email or username is required"
        "login_password_required": undefined, // In English: "Password is required"
        "window_title_open": undefined, // In English: "Open"
        "window_title_change_password": undefined, // In English: "Change Password"
        "window_title_select_font": undefined, // In English: "Select font…"
        "window_title_session_list": undefined, // In English: "Session List!"
        "window_title_set_new_password": undefined, // In English: "Set New Password"
        "window_title_instant_login": undefined, // In English: "Instant Login!"
        "window_title_publish_website": undefined, // In English: "Publish Website"
        "window_title_publish_worker": undefined, // In English: "Publish Worker"
        "window_title_authenticating": undefined, // In English: "Authenticating..."
        "window_title_refer_friend": undefined, // In English: "Refer a friend!"
        "desktop_show_desktop": undefined, // In English: "Show Desktop"
        "desktop_show_open_windows": undefined, // In English: "Show Open Windows"
        "desktop_exit_full_screen": undefined, // In English: "Exit Full Screen"
        "desktop_enter_full_screen": undefined, // In English: "Enter Full Screen"
        "desktop_position": undefined, // In English: "Position"
        "desktop_position_left": undefined, // In English: "Left"
        "desktop_position_bottom": undefined, // In English: "Bottom"
        "desktop_position_right": undefined, // In English: "Right"
        "item_shared_with_you": undefined, // In English: "A user has shared this item with you."
        "item_shared_by_you": undefined, // In English: "You have shared this item with at least one other user."
        "item_shortcut": undefined, // In English: "Shortcut"
        "item_associated_websites": undefined, // In English: "Associated website"
        "item_associated_websites_plural": undefined, // In English: "Associated websites"
        "no_suitable_apps_found": undefined, // In English: "No suitable apps found"
        "window_click_to_go_back": undefined, // In English: "Click to go back."
        "window_click_to_go_forward": undefined, // In English: "Click to go forward."
        "window_click_to_go_up": undefined, // In English: "Click to go one directory up."
        "window_title_public": undefined, // In English: "Public"
        "window_title_videos": undefined, // In English: "Videos"
        "window_title_pictures": undefined, // In English: "Pictures"
        "window_title_puter": undefined, // In English: "Puter"
        "window_folder_empty": undefined, // In English: "This folder is empty"
        "manage_your_subdomains": undefined, // In English: "Manage Your Subdomains"
        "open_containing_folder": undefined, // In English: "Open Containing Folder"
    }
};

export default hy;
